import React from "react";
import SensorBase from "./SensorBase";
import { t } from "../../../services/locale.service";
import { TCustomProcessFn } from "../../plotChart/types";
import { TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";

const FIELD = "deltaT";
const UNIT = "°C";


const generateColorForItem = (item: TDataItem): string => {
  const deltaT = Number(item.deltaT ?? 0); // Default value if deltaT is undefined

  if (deltaT < 2) {
    return "#F4D03F"; // Yellow: Below minimum threshold
  } else if (deltaT >= 2 && deltaT <= 10) {
    return "#0c9611"; // Green: Within optimal range
  } else if (deltaT > 10 && deltaT <= 14) {
    return "#F4D03F"; // Yellow: Moderately high
  } else if (deltaT > 14) {
    return "red"; // Red: Above maximum threshold
  } else {
    return "grey"; // Default: If no condition matches
  }
};


const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse,
  startDate: string,
  endDate: string
) => {
  console.log("Start Date:", startDate, "End Date:", endDate);

  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(item),  
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
  };
};

const DeltaT: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT} about={t("AboutDeltaT")}
      customProcessFn={customProcessFn}
    ></SensorBase>
  );
};

export default DeltaT;



// local interface 
// interface LocalItem {
//   timestamp:string;
//   deltaT:number;
//   [field: string]: number | string;
// }
